<iframe
  *ngIf="url"
  [src]="url"
  frameborder="0"
  title="Hangfire Dashboard"
></iframe>


// WEBPACK FOOTER //
// ./src/app/developer/hangfire-dashboard/hangfire-dashboard.component.html